import type { MutableRefObject } from "react";
import { useCallback } from "react";

const usePopoverInteraction = (
  panelRef: MutableRefObject<HTMLDivElement | null>,
  popoverSelector: string,
) => {
  const getAvailablePopovers = () =>
    Array.from(document.querySelectorAll(popoverSelector));

  /**
   * @param {Node} relatedTarget
   * @return {{withinCurrentPopoverRef: boolean, withinAnotherPopover: boolean, outsideOfPopovers: boolean}|undefined}
   */
  const getUserInteraction = useCallback(
    (relatedTarget) => {
      if (!panelRef?.current || !popoverSelector) {
        return;
      }

      let withinCurrentPopoverRef = false,
        withinAnotherPopover = false;

      for (const popover of getAvailablePopovers()) {
        if (!popover.contains(relatedTarget)) {
          continue;
        }

        if (popover.contains(panelRef.current)) {
          withinCurrentPopoverRef = true;
          break;
        }

        withinAnotherPopover = true;
        break;
      }

      return {
        withinCurrentPopoverRef,
        withinAnotherPopover,
        outsideOfPopovers: !withinCurrentPopoverRef && !withinAnotherPopover,
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [panelRef],
  );

  return { getUserInteraction };
};

export default usePopoverInteraction;
